const actionTypeIdentifier = '0368A170-3BA4-4492-AD75-74A52BA0E086';

export const getOrderDetails = `GET-ORDER-DETAILS-${actionTypeIdentifier}`;
export const getNewQuotationDetails = `GET-ORDER-DETAILS-Quotation${actionTypeIdentifier}`;
export const getVendorList = `GET-ORDER-VENDOR-LIST${actionTypeIdentifier}`;
export const getAssignedTEMAnalystDropdown = `GET-ORDER-ASSIGNED-TEM-ANALYST-DROPDOWN-${actionTypeIdentifier}`;
export const getOrderStatusDropdown = `GET-ORDER-ORDER-STATUS-DROPDOWN-${actionTypeIdentifier}`;
export const getApprovalStatusDropdown = `GET-ORDER-APPROVAL-STATUS-DROPDOWN-${actionTypeIdentifier}`;
export const getLocationCountryDropdown = `GET-ORDER-LOCATION-COUNTRY-DROPDOWN-${actionTypeIdentifier}`;
export const getLocationDeliveryAddressDropdown = `GET-ORDER-LOCATION-DELIVERY-ADDRESS-DROPDOWN-${actionTypeIdentifier}`;
export const getUserContactEmailDropdown = `GET-ORDER-USER-CONTACT-EMAIL-DROPDOWN-${actionTypeIdentifier}`;
export const setCancelOrderStatus = `SET-CANCEL-ORDER-STATUS-${actionTypeIdentifier}`;
export const checkCircuitDuplicate = `CHECK-CIRCUIT-DUPLICATE-${actionTypeIdentifier}`;
export const setTEMAnalystLoading = `SET-TEM-ANALYST-LOADING-${actionTypeIdentifier}`;
export const setCountryLoading = `SET-COUNTRY-LOADING-${actionTypeIdentifier}`;
export const setDeliveryAddressLoading = `SET-DELIVERY-ADDRESS-LOADING-${actionTypeIdentifier}`;
export const setUserContactEmailLoading = `SET-USER-CONTACT-EMAIL-LOADING-${actionTypeIdentifier}`;
export const getTechnicalUserContactEmail = `GET-TECHNICAL-USER-CONTACT-EMAIL-${actionTypeIdentifier}`;



export const orderDetailsFormModel = {
    orderId: 0,
    orderNumber: '',
    requestor: '',
    owner: '',
    requestType: '',
    orderStatusId: 0,
    orderStatus: '',
    companyCode: '',
    assignedTEMAnalystId: 0,
    assignedTEMAnalyst: '',
    approvalStatusId: 0,
    approvalStatus: '',
    contractTerm: '',
    createdDate: '',
    orderCompletionDate: '',
    expediteRequest: false,
    wirelineApproverName: '',
    wirelineApproverEmail: '',
    wirelineApprovedDate: '',
    costCodeApproverName: '',
    costCodeApproverEmail: '',
    costCodeApprovedDate: '',
    lineManagerName: '',
    lineManagerEmail: '',
    lineManagerApprovedDate: '',
    secondLineManagerName: '',
    secondLineManagerEmail: '',
    secondLineManagerApprovedDate: '',
    needByDate: '',
    countryId: 0,
    countryCode: '',
    country: '',
    fixedLocation: false,
    deliveryAddressId: 0,
    deliveryAddress: '',
    preferredDeliveryAddress: '',
    localContactEmail: '',
    localContactFullName: '',
    localContactPhoneNumber: '',
    altContactId: 0,
    altContactEmail: '',
    altContactFullName: '',
    altContactPhoneNumber: '',
    techContactId: 0,
    techContactEmail: '',
    techContactFullName: '',
    techContactPhoneNumber: '',
    srNumber: '',
};